import {DefaultNoComponentGlobalToastNotificationConfig, TOAST_CONFIG} from './config/toast-config'
import {ToastNotificationComponent} from './toast-notification.component'
import type {GlobalToastNotificationConfig} from './config/interfaces/toast.interface'

export const DefaultGlobalToastNotificationConfig: GlobalToastNotificationConfig = {
  ...DefaultNoComponentGlobalToastNotificationConfig,
  toastComponent: ToastNotificationComponent,
}

export const provideToastNotification = (config: Partial<GlobalToastNotificationConfig> = {}) => {
  return {
    provide: TOAST_CONFIG,
    useValue: {
      default: DefaultGlobalToastNotificationConfig,
      config,
    },
  }
}
